import { createRoot } from 'react-dom/client'
// Axios
import axios from 'axios'
import { Chart, registerables } from 'chart.js'
import { QueryClient, QueryClientProvider } from 'react-query'
// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'

import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
// Imported once here so the lazily loaded page chunks (ADR-0022) agree on the
// stylesheet order; a page's own import of either file is then a no-op.
import 'flatpickr/dist/themes/light.css'
import './_metronic/assets/sass/components/scanner.css'
// The veranda shape editor and the item drawings are drawn on the checkout,
// the order page and production (ADR-0060): loaded once here, their rules stay
// out of the lazy pages' stylesheet ordering.
import './app/components/VerandaShape.css'
import './app/components/OrderItemDrawing.css'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider, setupAxios } from './app/modules/auth'
import { SystemSettingsProvider } from './app/modules/system-settings/SystemSettingsContext'
import { Provider } from 'react-redux';
import { configureStores } from './app/redux/store';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <SystemSettingsProvider>
            <Provider store={configureStores()}>
              <AppRoutes />
              <ToastContainer
                position="top-right"
                autoClose={3000}
                closeOnClick={true}
                style={{ top: "85px" }}
              />
            </Provider>
          </SystemSettingsProvider>
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}




